import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const IngestOriginPage = lazy(() =>
  import('../../pages/admin/ingest/IngestOriginPage').then((m) => ({
    default: m.IngestOriginPage,
  })),
);

export const Route = createFileRoute('/admin/ingest_/$origin')({
  component: () => (
    <Suspense
      fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%', transform: 'translateX(-50%)' }} />}
    >
      <IngestOriginPage />
    </Suspense>
  ),
});
